import React, { useEffect, useState } from "react";
import "../../.csscode/Table.css";
import "../../.csscode/App.css";
import { Box } from "@mui/material";
import { Modal } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import User from "./User";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "../../.csscode/PopUpModal.css";
import "../../.csscode/TablePage.css";
import { toast } from "sonner";
import swal from "sweetalert";
import ConfirmModal from "../constants/ConfirmModal";

const UserListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [userData, setUserData] = useState([{}]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  //Density making Compact
  const [density, setDensity] = useState("compact");

  const [addShow, setAddShow] = useState(false);
  const addHandleClose = () => {
    setShowConfirm(true);
  };
  const addHandleShow = () => setAddShow(true);

  const [editShow, setEditShow] = useState(false);
  const editHandleClose = () => {
    setShowConfirm(true);
  };
  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }
    setEditShow(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false); // your close logic
    setEditShow(false); // your close logic
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  /*Declare functions */
  const RemoveFunction = async () => {
    if (selectedData) {
      // Ensure selectedData is a string
      const selectedDataStr = String(selectedData);

      swal({
        title: "Do you want to remove?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmDelete) => {
        if (confirmDelete) {
          try {
            await axios
              .delete(apiUrl + "user/" + selectedData[0], { headers })
              .then((response) => {
                toast.success("Record" + " removed successfully.");
                window.location.reload();
              });
          } catch (error) {
            console.error("Error deleting record:", error);
          }
        }
      });
    } else {
      toast.warning("Please Select at least one value");
    }
  };

  const columns = [
    //columns decleration with name and style
    {
      field: "empcode",
      headerName: "Employee Code",
      width: 350,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "userid",
      headerName: "User",
      width: 400,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "active",
      headerName: "active  ",
      width: 300,
      headerAlign: "center",
      align: "center",
    },
    // { field: "type", headerName: "type  ", width: 200 ,headerAlign: 'center',align: 'center',},
  ];

  /*Initializer - Post Render */
  useEffect(() => {
    fetchData();
  }, [refresh]);

  const fetchData = async () => {
    try {
      axios
        .get(apiUrl + "user", { headers })
        .then((response) => {
          //for me
          setUserData(response.data);
          setFilterData(response.data);
          setRefresh(false);
          setSelectedData("");
        })
        .catch((error) => {
          console.log("error " + error);
          setUserData([{}]);
        });
    } catch (error) {
      setUserData([{}]);
    }
  };

  const handlesearch = (event) => {
    const getSearch = event.target.value;
    if (getSearch.length > 0) {
      const searchdata = userData.filter((item) =>
        item.userid.toLowerCase().includes(getSearch),
      );
      setUserData(searchdata);
    } else {
      setUserData(filterData);
    }
    setSerach(getSearch);
  };
  return (
    <>
      <div className="tablepage-div-1">
        <Box>
          <div className="tablepage-div-shadow-1">
            <div className="tablepage-div-shadow-2">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="divbtn">
                  <Tooltip title="Create new User" placement="top">
                    <button
                      to="create"
                      className="btn btn-success"
                      onClick={addHandleShow}
                    >
                      Add
                    </button>
                  </Tooltip>

                  <Modal show={addShow} onHide={addHandleClose} className="p-1">
                    {/* <Modal.Header closeButton /> */}
                    <Modal.Header closeButton className="modalhead">
                      <Modal.Title className="modaltitle">Add User</Modal.Title>{" "}
                      {/* Text added in the modal header */}
                    </Modal.Header>
                    <User
                      selectedId=""
                      mode="A"
                      onHide={addHandleClose}
                      setRefresh={setRefresh}
                    />
                  </Modal>

                  <Tooltip title="Edit Selected User" placement="top">
                    <button
                      to="create"
                      className="btn btn-warning"
                      onClick={editHandleShow}
                    >
                      Edit
                    </button>
                  </Tooltip>
                  <Modal
                    show={editShow}
                    onHide={editHandleClose}
                    className="p-1"
                  >
                    {/* <Modal.Header closeButton /> */}
                    <Modal.Header closeButton className="modalhead">
                      <Modal.Title className="modaltitle">
                        Edit User
                      </Modal.Title>{" "}
                      {/* Text added in the modal header */}
                    </Modal.Header>
                    <User
                      selectedId={selectedData && selectedData[0]}
                      mode="U"
                      onHide={editHandleClose}
                      setRefresh={setRefresh}
                    />
                  </Modal>
                  <Tooltip title="Delete Selected User" placement="top">
                    <button
                      to="create"
                      className="btn btn-danger"
                      onClick={RemoveFunction}
                    >
                      Delete
                    </button>
                  </Tooltip>
                </div>
                <div className="tablepage-search-div">
                  <div className="text-end">
                    <Tooltip title="Search by User Id" placement="left">
                      <input
                        className="tablepage-search-input"
                        ref={(input) => input && input.focus()}
                        type="text"
                        name="name"
                        value={serach}
                        onChange={(e) => handlesearch(e)}
                        placeholder="  Search..."
                      ></input>
                    </Tooltip>
                  </div>
                </div>
              </Box>
            </div>
          </div>
          <div className="tablepage-div-shadow-1">
            <div className="tablepage-div-shadow-2">
              <Box m="1px 0 0 0" className="tablepage-gatagrid-box">
                <DataGrid
                  density={density}
                  onDensityChange={(newDensityString) =>
                    setDensity(newDensityString)
                  }
                  rows={
                    userData !== null &&
                    userData.length > 0 &&
                    Object.keys(userData[0]).length !== 0 &&
                    userData
                  }
                  columns={columns}
                  components={{ Toolbar: GridToolbar }}
                  // checkboxSelection
                  onSelectionModelChange={(itm) => setSelectedData(itm)}
                />
              </Box>
            </div>
          </div>
        </Box>
      </div>
      <ConfirmModal
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default UserListing;
